// extracted by mini-css-extract-plugin
export var box = "_63-0";
export var check = "_63-1";
export var checkboxButton = "_63-6";
export var checkboxGroup = "_63-5";
export var disabled = "_63-7";
export var ghost = "_63-9";
export var input = "_63-2";
export var label = "_63-4";
export var normal = "_63-8";
export var uncheck = "_63-3";